import { motion, AnimatePresence } from 'framer-motion';
import { headerStyles } from "./Header";
import CrossIcon from '../assets/cross.svg';
import CheckIcon from '../assets/check.svg';
import { getFixedText } from '../utils';
import { infoSteps, onboardSteps } from './Start/constants';
import { useAppContext } from '../context';
import { createPortal } from 'react-dom';

interface IInfoModal {
    isShow: boolean;
    toggleShow: () => void;
}

export const InfoModal = ({ isShow, toggleShow }: IInfoModal) => {
    const { isMobile } = useAppContext();
    const renderMenu = (text: string) => {
        return (
            <div className="flex items-start gap-4 mb-3">
                <img src={CheckIcon} alt="Галочка" />
                <p className={`font-normal ${isMobile ? 'text-[15px] leading-[18px]' : 'text-[20px]/[24px]'}`}>{getFixedText(text)}</p>
            </div>
        )
    }

    return isMobile ? createPortal(
        <AnimatePresence>
            {isShow && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black bg-opacity-50 overflow-y-auto p-4 z-50 select-none"
                    style={{ WebkitOverflowScrolling: 'touch' }}
                >
                    <div className="min-h-[calc(100vh-32px)] py-4 flex items-center justify-center">
                        <motion.div
                            initial={{ y: "100%", opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: "100%", opacity: 0 }}
                            transition={{ type: "spring", damping: 25, stiffness: 500 }}
                            className="bg-white p-6 rounded-2xl w-full max-w-[358px] my-auto relative"
                        >
                            <button
                                onClick={toggleShow}
                                className={`${headerStyles.iconBox} right-4 bg-vkusvill-green absolute`}
                            >
                                <img src={CrossIcon} alt="close" className="mx-auto" />
                            </button>
                            <div className="mt-12 mb-6">
                                <h2 className="font-villula text-[22px]/[22px] font-normal max-w-[310px] mb-4 mx-auto short text-center">{getFixedText('ПаМяТка ЭкСпЕрТа пО КаЧеСтВу ВкУсВилла')}</h2>
                            </div>
                            <div className="space-y-3">
                                {infoSteps.map((el, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.1 }}
                                    >
                                        {renderMenu(el)}
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>,
        document.body
    ) : createPortal(
        <AnimatePresence>
            {isShow && (
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    className="fixed inset-0 bg-black bg-opacity-50 overflow-y-auto p-4 z-50 select-none"
                >
                    <div className="min-h-[calc(100vh-32px)] py-4 flex items-center justify-center">
                        <motion.div
                            initial={{ y: "100%", opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            exit={{ y: "100%", opacity: 0 }}
                            transition={{ type: "spring", damping: 25, stiffness: 500 }}
                            className="relative bg-white rounded-2xl w-full max-w-[840px] px-16 py-20 my-auto"
                        >
                            <button
                                onClick={toggleShow}
                                className={`!-top-4 ${headerStyles.iconBox} -right-4  bg-vkusvill-green absolute`}
                            >
                                <img src={CrossIcon} alt="close" className="mx-auto" />
                            </button>
                            <div className="mb-6">
                                <h2 className={`font-villula text-cgrey text-[40px]/[40px]`}>{getFixedText('ПаМяТка ЭкСпЕрТа пО КаЧеСтВу ВкУсВилла')}</h2>
                            </div>
                            <div className="space-y-3">
                                {infoSteps.map((el, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ delay: index * 0.1 }}
                                    >
                                        {renderMenu(el)}
                                    </motion.div>
                                ))}
                            </div>
                        </motion.div>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>, document.body)
}